import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../../components/SEO';
import './Legal.css';

const LegalNotice = () => {
  const { i18n } = useTranslation();
  const isFr = i18n.language === 'fr';

  return (
    <div className="legal-page">
      <SEO
        title={isFr ? 'Mentions légales' : 'Legal Notice'}
        description={isFr
          ? 'Mentions légales du site OPTEAM Services : éditeur, directeur de la publication, hébergeur et propriété intellectuelle.'
          : 'Legal notice of the OPTEAM Services website: publisher, publication director, hosting provider and intellectual property.'
        }
        canonical="/legal-notice"
      />

      <section className="legal-hero">
        <div className="container">
          <h1>{isFr ? 'Mentions légales' : 'Legal Notice'}</h1>
          <p>{isFr ? 'Dernière mise à jour : 1er novembre 2026' : 'Last updated: November 1, 2026'}</p>
        </div>
      </section>

      <section className="legal-content">
        <div className="container">
          {isFr ? (
            <div className="legal-body">
              <h2>Éditeur du site</h2>
              <p>
                Le site <strong>www.opteam-services.com</strong> est édité par <strong>OPTEAM Services</strong>,
                société par actions simplifiée (SAS) au capital de 50 000 €, immatriculée au Registre du Commerce
                et des Sociétés de Nanterre sous le numéro 979 611 811.
              </p>
              <ul>
                <li>Siège social : 1 rue Marcel Allégot, 92190 Meudon, France</li>
                <li>N° de TVA intracommunautaire : FR61979611811</li>
                <li>E-mail : <a href="mailto:contact@opteam-services.com">contact@opteam-services.com</a></li>
                <li>Téléphone : <a href="tel:+33638831750">+33 (0) 6 38 83 17 50</a></li>
              </ul>

              <h2>Directeur de la publication</h2>
              <p>
                Jean-Christophe Lhotellier, en qualité de représentant légal de SNL INVEST GROUP,
                Présidente d'OPTEAM Services.
              </p>

              <h2>Hébergeur</h2>
              <p>
                Le site est hébergé par <strong>Google Ireland Limited</strong> (service Firebase Hosting),
                Gordon House, Barrow Street, Dublin 4, Irlande. Téléphone : +353 1 436 1000.
              </p>

              <h2>Propriété intellectuelle</h2>
              <p>
                L'ensemble des contenus de ce site (textes, logos, charte graphique, images, vidéos, études de cas
                et documents téléchargeables) est la propriété d'OPTEAM Services ou de ses partenaires, et est
                protégé par le droit de la propriété intellectuelle. Toute reproduction, représentation ou
                adaptation, totale ou partielle, sans autorisation écrite préalable est interdite.
              </p>
              <p>
                Les marques et logos des clients et éditeurs cités (UiPath, Blue Prism, Automation Anywhere,
                Microsoft…) appartiennent à leurs titulaires respectifs et sont reproduits à titre de référence.
              </p>

              <h2>Données personnelles</h2>
              <p>
                Le traitement des données personnelles collectées sur ce site est décrit dans
                notre <Link to="/privacy-policy">politique de confidentialité</Link>.
              </p>

              <h2>Responsabilité</h2>
              <p>
                OPTEAM Services s'efforce d'assurer l'exactitude des informations publiées sur ce site, sans
                pouvoir en garantir l'exhaustivité. Les liens vers des sites tiers sont fournis à titre
                informatif ; OPTEAM Services n'est pas responsable de leur contenu.
              </p>

              <h2>Droit applicable</h2>
              <p>
                Les présentes mentions légales sont soumises au droit français. En cas de litige, et à défaut
                de résolution amiable, les tribunaux compétents du ressort de la Cour d'appel de Versailles
                seront seuls compétents.
              </p>
            </div>
          ) : (
            <div className="legal-body">
              <h2>Publisher</h2>
              <p>
                The website <strong>www.opteam-services.com</strong> is published by <strong>OPTEAM Services</strong>,
                a French simplified joint-stock company (SAS) with a share capital of €50,000, registered with the
                Nanterre Trade and Companies Register under number 979 611 811.
              </p>
              <ul>
                <li>Registered office: 1 rue Marcel Allégot, 92190 Meudon, France</li>
                <li>EU VAT number: FR61979611811</li>
                <li>Email: <a href="mailto:contact@opteam-services.com">contact@opteam-services.com</a></li>
                <li>Phone: <a href="tel:+33638831750">+33 (0) 6 38 83 17 50</a></li>
              </ul>

              <h2>Publication director</h2>
              <p>
                Jean-Christophe Lhotellier, as legal representative of SNL INVEST GROUP, President of
                OPTEAM Services.
              </p>

              <h2>Hosting provider</h2>
              <p>
                The website is hosted by <strong>Google Ireland Limited</strong> (Firebase Hosting service),
                Gordon House, Barrow Street, Dublin 4, Ireland. Phone: +353 1 436 1000.
              </p>

              <h2>Intellectual property</h2>
              <p>
                All content on this website (text, logos, brand identity, images, videos, case studies and
                downloadable documents) is the property of OPTEAM Services or its partners and is protected by
                intellectual property law. Any reproduction, representation or adaptation, in whole or in part,
                without prior written consent is prohibited.
              </p>
              <p>
                The trademarks and logos of the clients and vendors mentioned (UiPath, Blue Prism, Automation
                Anywhere, Microsoft…) belong to their respective owners and are shown for reference purposes.
              </p>

              <h2>Personal data</h2>
              <p>
                The processing of personal data collected on this website is described in
                our <Link to="/privacy-policy">privacy policy</Link>.
              </p>

              <h2>Liability</h2>
              <p>
                OPTEAM Services strives to ensure the accuracy of the information published on this website
                but cannot guarantee its completeness. Links to third-party websites are provided for
                information only; OPTEAM Services is not responsible for their content.
              </p>

              <h2>Governing law</h2>
              <p>
                This legal notice is governed by French law. In the event of a dispute, and failing an amicable
                settlement, the competent courts within the jurisdiction of the Versailles Court of Appeal shall
                have sole jurisdiction.
              </p>
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default LegalNotice;
